import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { LayoutService } from '../layout.service/layout.service';
import { LayoutSidebarService } from '../sidebar/sidebar.service';
import * as i0 from "@angular/core";
import * as i1 from "../layout.service/layout.service";
import * as i2 from "../sidebar/sidebar.service";
export let LayoutContentbarsService = /*#__PURE__*/(() => {
  class LayoutContentbarsService {
    constructor(layout, sidebar) {
      this.layout = layout;
      this.sidebar = sidebar;
      this._topbarItemClick = new BehaviorSubject(false);
      this._activeTopbarItem = new BehaviorSubject(null);
      this.activeTopbarItem$ = this._activeTopbarItem.asObservable();
      this.topbarItemClick$ = this._topbarItemClick.asObservable();
      this.showTopBar$ = layout.layoutMode$.pipe(map(mode => {
        if (mode.indexOf('hidetopbar') > -1) return false;
        if (mode.indexOf('showtopbar') > -1) return true;
        return mode.indexOf('fullscreen') === -1;
      }));
      this.showBottomBar$ = layout.layoutMode$.pipe(map(mode => {
        if (mode.indexOf('hidebottombar') > -1) return false;
        if (mode.indexOf('showbottombar') > -1) return true;
        return mode.indexOf('fullscreen') === -1;
      }));
    }
    onTopbarItemClick(event, item) {
      this._topbarItemClick.next(true);
      if (this._activeTopbarItem.value === item) {
        this._activeTopbarItem.next(null);
      } else {
        this._activeTopbarItem.next(item);
      }
      event.preventDefault();
    }
    static {
      this.ɵfac = function LayoutContentbarsService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LayoutContentbarsService)(i0.ɵɵinject(i1.LayoutService), i0.ɵɵinject(i2.LayoutSidebarService));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: LayoutContentbarsService,
        factory: LayoutContentbarsService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return LayoutContentbarsService;
})();